import * as amplitude from '@amplitude/analytics-browser';
import { plugin as engagementPlugin } from '@amplitude/engagement-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

const FLUSH_MAX_RETRIES = 35;

const setupAnalytics = (options: {
  enableAmplitude: boolean;
  apiKey: string;
  version: string;
}) => {
  if (options.enableAmplitude) {
    amplitude.add(engagementPlugin());

    amplitude.add(
      sessionReplayPlugin({
        sampleRate: 1,
      })
    );

    amplitude.init(options.apiKey, {
      autocapture: true,
      appVersion: options.version,
      flushMaxRetries: FLUSH_MAX_RETRIES,
    });
  }
};

interface User {
  userId: string;
  userRole: 'OWNER' | 'TECHNICIAN' | 'AIRSHIP_ADMIN';
  organizationId: string;
}

const setAnalyticsUser = (user: User) => {
  const identifyEvent = new amplitude.Identify();
  identifyEvent.setOnce('organizationId', user.organizationId);
  identifyEvent.setOnce('userRole', user.userRole);
  amplitude.setUserId(user.userId);
  amplitude.identify(identifyEvent);
};

const amplitudeTrackEvent = (
  eventName: string,
  eventProperties?: Record<string, string | number>
) => amplitude.track(eventName, eventProperties);

const amplitudeFlush = () => amplitude.flush();

export {
  amplitudeFlush,
  amplitudeTrackEvent,
  setAnalyticsUser,
  setupAnalytics,
};
